module.exports = __webpack_public_path__ + "assets/images/premium-features/shift-acceptance-53cff4.png";